"use client";

import React, {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
  ReactNode,
} from "react";

interface HeaderActionsContextType {
  actions: ReactNode;
  setActions: (actions: ReactNode) => void;
  clearActions: () => void;
}

const HeaderActionsContext = createContext<
  HeaderActionsContextType | undefined
>(undefined);

export const useHeaderActions = () => {
  const context = useContext(HeaderActionsContext);
  if (!context) {
    throw new Error(
      "useHeaderActions must be used within a HeaderActionsProvider",
    );
  }
  return context;
};

interface HeaderActionsProviderProps {
  children: ReactNode;
}

export const HeaderActionsProvider = ({
  children,
}: HeaderActionsProviderProps) => {
  const [actions, setActions] = useState<ReactNode>(null);

  const clearActions = useCallback(() => setActions(null), []);

  const value = useMemo(
    () => ({ actions, setActions, clearActions }),
    [actions, setActions, clearActions],
  );

  return (
    <HeaderActionsContext.Provider value={value}>
      {children}
    </HeaderActionsContext.Provider>
  );
};
